export function handleError(response) {
  const message = `An error occurred: ${response.statusText}`;
  window.alert(message);
}

//get a random number with a max
export function getRandomWithRange(max) {
  return Math.floor(Math.random() * max);
}

//get the traduction json and set the lang
export function loadLenguage() {
  try {
    const jsonTraduction = require("../json/traduction.json");

    //if not set the lang, set with defualt of the browser, if does't match def=it
    if (!sessionStorage.getItem("leng")) {
      Object.keys(jsonTraduction).map((key) => {
        if (key === navigator.language.slice(0, 2))
          sessionStorage.setItem("leng", navigator.language.slice(0, 2));
        else sessionStorage.setItem("leng", "it");
      });
    }
    return jsonTraduction;
  } catch (error) {
    return console.error(error);
  }
  return null;
}

//get photo json
export function loadPhotosJson(forceLoad = false) {
  try {
    //try to get the sessionStorage json
    let sessionJson = window.sessionStorage.getItem("original-photo-json");

    //if exist return the obj, else import the json and upload on memory
    if (sessionJson && forceLoad === false) {
      return JSON.parse(sessionJson);
    } else {
      const photoJson = require("../json/photos.json");
      window.sessionStorage.setItem("original-photo-json", JSON.stringify(photoJson));
      return photoJson;
    }
  } catch (error) {
    return console.error(error);
  }
}

//to have a unique controlled number
export function getUniSerialNumber() {
  //get the sessionStorage number
  const sessionSerialNumber = parseInt(
    window.sessionStorage.getItem("uni-serial-number"),
  );

  //if exists and is >= 0
  if (sessionSerialNumber >= 0) {
    //set number and save the number on memory, return value
    setUniSerialNumber(sessionSerialNumber + 1);
    //ritorno il valore
    return sessionSerialNumber + 1;
  } else {
    //if new set the number with 0 and save it
    setUniSerialNumber(0);
    return 0;
  }
}

//method for save the number into sessionStorage
export function setUniSerialNumber(serialNumberToSet) {
  if (serialNumberToSet === 0) {
    window.sessionStorage.setItem("uni-serial-number", 0);
  } else {
    window.sessionStorage.setItem("uni-serial-number", serialNumberToSet);
  }
}

//find into the array a specific filter
/**
 * @param {*} array => is the array in which you have to look ([{photo},{photo},{photo},{photo},])
 * @param {*} toSearch => is the name of the key ("year")
 * @param {*} filter => is the value for that key (2014)
 * @param {*} filterIsArray => if the filter param is an array
 * @returns
 */
export function filterInPhotos(array, toSearch, filter, filterIsArray = false) {
  //check the filter isn't array, search directly the value
  if (!filterIsArray && !Array.isArray(filter)) {
    return array.filter((photo) => {
      return photo[toSearch] === filter ? photo : null;
    });
  } else {
    //TODO: check this else
    //for each filter param i filter the array and return the new array filtered
    const newArray = filter.map((fil) => {
      return array.filter((photo) => {
        return photo[toSearch].includes(fil) ? photo : null;
      });
    });

    if (Array.isArray(newArray[0])) return newArray[0];
    else return newArray;
  }
}

//filter the array of photos for find all the category
export function getCategories(photos) {
  let categories = [];
  photos.map((photo) => {
    if (!categories.includes(photo.category)) categories.push(photo.category);
    return null;
  });

  return categories;
}

//filter the array of photos for find all the years in order
export function getYears(photos) {
  let years = [];
  photos.map((photo) => {
    if (!years.includes(photo.year)) years.push(photo.year);
    return null;
  });

  return years.sort();
}

//filter all the filters that are passed to (es: city=lodi&year=2022-2024)
//TODO: OLD VERSION, TO CHANGE with the new
export const photoFilter = (photos, filterKey, filterValue = "", multipleValue = []) => {
  console.warn(photos, filterKey, filterValue);
  //if the filter aren't multiple
  if (multipleValue.length === 0) {
    //if not tags
    if (filterKey !== "tags") {
      return photos.filter((photo) => {
        if (String(photo[filterKey]) === String(filterValue)) return photo;
        return null;
      });
    } else {
      //if tags
      return photos.filter((photo) => {
        if (photo[filterKey].includes(filterValue)) return photo;
        return null;
      });
    }
  } else {
    //if multiple filter (es: tags=mare-fiume)
    let newArrayFiltered = [];

    photos.filter((photo) => {
      multipleValue.forEach((value) => {
        //if not tags
        if (filterKey !== "tags") {
          if (String(photo[filterKey]) === String(value))
            return newArrayFiltered.push(photo);
        } else {
          //if tags, i searched if the value is included into
          if (photo[filterKey].includes(value)) return newArrayFiltered.push(photo);
        }
        return null;
      });
    });
    return newArrayFiltered;
  }
};
